import { render, staticRenderFns } from "./SettingKontrakPerusahaan.vue?vue&type=template&id=6ca86f8e&scoped=true"
import script from "./SettingKontrakPerusahaan.vue?vue&type=script&lang=js"
export * from "./SettingKontrakPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./SettingKontrakPerusahaan.vue?vue&type=style&index=0&id=6ca86f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca86f8e",
  null
  
)

export default component.exports